import {
    SET_FOOTER_CONTENT
} from '@/store/mutation.types';

export default {
    state: () => ({
        footerContent: null
    }),

    actions: {
        saveFooterContent: ({ commit }, footerContent) => {
            commit(SET_FOOTER_CONTENT, footerContent);
        }
    },

    mutations: {
        [SET_FOOTER_CONTENT]: (state, footerContent) => {
            state.footerContent = footerContent;
        }
    }
};
